import { render, staticRenderFns } from "./WithdrawMessage.vue?vue&type=template&id=45122540&"
import script from "./WithdrawMessage.vue?vue&type=script&lang=ts&"
export * from "./WithdrawMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports